module.exports = __webpack_public_path__ + "static/butcher-2b43690302668a6e0fc1e34d9e4031ba.png";